(function($){

    const personal_inputs = [
        'personal_name',
        'personal_kana',
        'personal_zip',
        'personal_pref',
        'personal_address1',
        'personal_address2'
    ];

    const use_energy_inputs = [
        'gas_code',
        'salesman',
        'salesman_number_1',
        'salesman_number_2',
        'salesman_number_3',
    ];
    
    const FUNC = {
        submitCheck: function() {
            if($('input[name="pdf1"]').val() == 'ok'){
                $('.pdf1').addClass('checked');
            }
            if($('input[name="pdf2"]').val() == 'ok'){
                $('.pdf2').addClass('checked');
            }
            if($('input[name="pdf3"]').val() == 'ok'){
                $('.pdf3').addClass('checked');
            }
            if($('input[name="pdf4"]').val() == 'ok'){
                $('.pdf4').addClass('checked');
            }
            if($('input[name="contract-plan"]:checked').val() != 'with生活サポートプラン（生活サポート付）'){
                if($('input[name="pdf1"]').val() == 'ok' && $('input[name="pdf2"]').val() == 'ok'){
                    $('input[name="submitConfirm"]').prop('disabled',false);
                } else {
                    $('input[name="submitConfirm"]').prop('disabled',true);
                }
            } else {
                if( $('input[name="pdf1"]').val() == 'ok' 
                    && $('input[name="pdf2"]').val() == 'ok' 
                    && $('input[name="pdf3"]').val() == 'ok' 
                    && $('input[name="pdf4"]').val() == 'ok' ){
                    $('input[name="submitConfirm"]').prop('disabled',false);
                } else {
                    $('input[name="submitConfirm"]').prop('disabled',true);
                }
            }
        },
        personalDisableCheck: function(obj) {
            if(obj.prop('checked')){
                disable_flg = true;
            } else {
                disable_flg = false;
            }

            for(i in personal_inputs){
                $('[name^="'+personal_inputs[i]+'"]').prop('disabled',disable_flg);
            }
        },
        useKingasCheck: function(obj) {
            if(obj.prop('checked')){
                disable_flg = false;
            } else {
                disable_flg = true;
            }

            for(i in use_energy_inputs){
                $('[name^="'+use_energy_inputs[i]+'"]').prop('disabled',disable_flg);
            }
        },
        planCheck: function() {
            const _e30a = $('[name="contract-electric"][value="30A"]');
            if($('[name="contract-plan"]:checked').val() === 'with生活サポートプラン（生活サポート付）'){
                $('.pdf-lifesupport').addClass('active');
                _e30a.prop('disabled',true).prop('checked',false);
                _e30a.parent().addClass('disabled');
            } else {
                $('.pdf-lifesupport').removeClass('active');
                _e30a.prop('disabled',false);
                _e30a.parent().removeClass('disabled');
            }
        },
        planConfirm: function(){
            if($('[name="contract-plan"]').val() == 'with生活サポートプラン（生活サポート付）'){
                $('.pdf-confirm .pdf-lifesupport').addClass('active');
            }
        }
    }

    $(document)
        .ready(function(){
            FUNC.submitCheck();
            
            if(location.href.indexOf('confirm') == -1){
                FUNC.personalDisableCheck($('.disable_personal'));
                FUNC.useKingasCheck($('.use_energy'));
                FUNC.planCheck();
            }
            if(location.href.indexOf('confirm') != -1){
                FUNC.planConfirm();
            }
        })
        .on('change','[name="contract-plan"]',function(e){
            FUNC.planCheck();
            FUNC.submitCheck();
        })
        .on('click','.link-pdf1',function(){
            $('input[name="pdf1"]').val('ok');
            FUNC.submitCheck();
        })
        .on('click','.link-pdf2',function(){
            $('input[name="pdf2"]').val('ok');
            FUNC.submitCheck();
        })
        .on('click','.link-pdf3',function(){
            $('input[name="pdf3"]').val('ok');
            FUNC.submitCheck();
        })
        .on('click','.link-pdf4',function(){
            $('input[name="pdf4"]').val('ok');
            FUNC.submitCheck();
        })
        .on('keyup','.zip',function(e){
            AjaxZip3.zip2addr('zip1','zip2','pref','address1');
        })
        .on('keyup','.personal_zip',function(e){
            AjaxZip3.zip2addr('personal_zip1','personal_zip2','personal_pref','personal_address1');
        })
        .on('click','.disable_personal',function(e){
            FUNC.personalDisableCheck($(this));
        })
        .on('click','.use_energy',function(e){
            FUNC.useKingasCheck($(this));
        });
    
    // sub action
    $(window).on('load',function(){
        if(location.href.indexOf('confirm') == -1){
            FUNC.submitCheck();
            FUNC.planCheck();
            $(window).off('load');
        }
    });

})(jQuery);

const vueSmoothScroll = window['VueSmoothScroll'];
Vue.use(vueSmoothScroll);

const app = new Vue({
    el: "#app",
    data: {
        isMenuActive: false,
        isMonthPayActive: '_payment-btn-bank',
        errors:{
            month_price: false,
            year_value: false
        },
        monthly_per:{
            '1月': 0.0740774752247606,
            '2月': 0.075451128591431,
            '3月': 0.0622779908291578,
            '4月': 0.0773197656736616,
            '5月': 0.107769649232914,
            '6月': 0.0859733679609861,
            '7月': 0.0673206315071113,
            '8月': 0.0739382020773092,
            '9月': 0.0824570461363358,
            '10月': 0.112400099237778,
            '11月': 0.0970233748323579,
            '12月': 0.0839912686961965
        },
        month:{
            plan: '30A',
            pay: 'bank',
            month: '1月',
            price: null,
            used: null
        },
        year:{
            plan: '30A',
            pay: 'bank',
            type: 'price', // or used
            value: {
                month1: null,
                month2: null,
                month3: null,
                month4: null,
                month5: null,
                month6: null,
                month7: null,
                month8: null,
                month9: null,
                month10: null,
                month11: null,
                month12: null
            },
            value_unit: '円'
        },
        calc:{
            ce:{
                base:{
                    '30A': 858,
                    '40A': 1144,
                    '50A': 1430,
                    '60A': 1716,
                },
                plus:{
                    '120':21.04,
                    '300':25.51,
                    '301':28.46
                }
            },
            og:{
                base:{
                    '30A': 865.74,
                    '40A': 955.64,
                    '50A': 1247.92,
                    '60A': 1539.55,
                },
                plus:{
                    '120':21.48,
                    '300':26.03,
                    '301':27.26
                }
            },
        },
        result:{
            title: null,
            calc_title: null,
            year_kwh: 0,
            ce_year_price: 0,
            og_year_price: 0,
            diff_price: 0,
            diff_price_text: null,
            month_text: null
        }
    },
    computed: {
        yearType:  {
            get: function() {
                return this.year.type;
            },
            set: function(value) {
                this.year.type = value;
                if(value == 'price'){
                    this.year.value_unit = '円';
                } else {
                    this.year.value_unit = 'kwh';
                }
            }
        },
    },
    methods: {
        toggleMenu: function() {
            this.isMenuActive = !this.isMenuActive;
        },
        monthPay: function(e) {
            if(e.currentTarget.classList.contains('_payment-btn-bank')){
                this.month.pay = 'bank';
            } else if(e.currentTarget.classList.contains('_payment-btn-card')){
                this.month.pay = 'card';
            }
        },
        monthCalc: function() {
            
            this.result.year_kwh = 0;
            this.result.ce_year_price = 0;
            this.result.og_year_price = 0;
            this.result.diff_price = 0;
            let ce_year_price = 0;
            let og_year_price = 0;

            // エラーハンドリング
            this.errors.month_price = false;

            if(!this.month.price && !this.month.used){
                this.errors.month_price = true;
                return false;
            }
            
            if(this.month.price){
                // 料金から使用量を算出
                let re_enegry_key = _getReEnergyKey(this.month.month);
                this.month.used = _getKwhByPrice(
                    this.month.price,
                    this.calc.ce.base[this.month.plan],
                    this.calc.ce.plus,
                    window.fuel_costs[this.month.month],
                    window.re_energy_costs[re_enegry_key]
                );
            }
            
            // 年間のkwh
            // const yearKwh = Math.floor(Math.round(this.month.used / this.monthly_per[this.month.month], 0) / 10) * 10;
            const yearKwh = Math.round(this.month.used / this.monthly_per[this.month.month]);

            this.result.year_kwh = yearKwh;

            // 中部電力の年間算出
            ce_year_price = _yearCalcByKwh(
                this.calc.ce.base[this.month.plan],
                this.calc.ce.plus,
                yearKwh,
                this.monthly_per,
                this.month.used,
                window.fuel_costs,
                window.re_energy_costs
            );
            
            // 大阪ガスの年間算出
            og_year_price = _yearCalcByKwh(
                this.calc.og.base[this.month.plan],
                this.calc.og.plus,
                yearKwh,
                this.monthly_per,
                this.month.used,
                window.fuel_costs_og,
                window.re_energy_costs,
                0.02
            );
            
            // 口座振替の場合はマイナス
            if(this.month.pay === 'bank'){
                ce_year_price -= 660;
            }

            if(ce_year_price){
                this.result.ce_year_price = ce_year_price.toLocaleString();
            }
            if(og_year_price){
                this.result.og_year_price = og_year_price.toLocaleString();
            }
            if(ce_year_price > og_year_price){
                const diff_price = (ce_year_price - og_year_price);
                this.result.diff_price = diff_price.toLocaleString();
                this.result.diff_price_text = 'お安く';
            } else {
                const diff_price = (og_year_price - ce_year_price);
                this.result.diff_price = diff_price.toLocaleString();
                this.result.diff_price_text = 'お高く';
            }
            
            const date = new Date();
            this.result.title = 'ひと月試算結果';
            this.result.calc_title = '[電気料金単価による比較]';
            this.result.month_text = '※電気代から試算する場合、使用量の割戻し過程で、実際とは相違が出る場合があります。より正確な試算を希望される場合には、12ヶ月分の電気使用量をご確認頂き、「きっちり年間試算」にて12ヶ月分の使用量（kwh）を入力して計算ください。';

            // scroll
            this.$smoothScroll({
                scrollTo: document.querySelector('#calc-end'),
                duration: 1000,
                offset: -50,
            });
        },
        yearPay: function(e) {
            if(e.currentTarget.classList.contains('_payment-btn-bank')){
                this.year.pay = 'bank';
            } else if(e.currentTarget.classList.contains('_payment-btn-card')){
                this.year.pay = 'card';
            }
        },
        yearCalc: function() {
            
            this.result.month_text = null;
            this.result.year_kwh = 0;
            this.result.ce_year_price = 0;
            this.result.og_year_price = 0;
            this.result.diff_price = 0;

            // エラーハンドリング : すべての月が入っていない場合
            let values = {};
            for(val in this.year.value){
                if(! this.year.value[val]){
                    this.errors.year_value = true;
                    return false;
                }
                values[val] = this.year.value[val];
            }
            
            let ce_year_price = 0;
            let og_year_price = 0;
            
            // 料金から使用量を算出
            for(val in values){
                let fuel_key = val.replace(/month([0-9]+)/,'$1月');
                let re_enegry_key = _getReEnergyKey(fuel_key);
                let tmp_kwh = 0;
                let tmp_og_price = 0;
            
                if(this.year.type === 'price'){

                    // 各月の使用量の算出
                    tmp_kwh = _getKwhByPrice(
                        parseInt(this.year.value[val]),
                        this.calc.ce.base[this.year.plan],
                        this.calc.ce.plus,
                        window.fuel_costs[fuel_key],
                        window.re_energy_costs[re_enegry_key]
                    );
                    
                    ce_year_price += parseInt(this.year.value[val]);
                    
                } else {

                    tmp_kwh = parseInt(values[val]);

                    // 中部電力の金額算出
                    tmp_ce_price = _sigleMonthCalcByKwh(
                        this.calc.ce.base[this.year.plan],
                        this.calc.ce.plus,
                        tmp_kwh,
                        window.fuel_costs[fuel_key],
                        window.re_energy_costs[re_enegry_key]
                    );

                    ce_year_price += tmp_ce_price;
                }
                
                // 大阪ガスの金額算出
                tmp_og_price = _sigleMonthCalcByKwh(
                    this.calc.og.base[this.year.plan],
                    this.calc.og.plus,
                    tmp_kwh,
                    window.fuel_costs_og[fuel_key],
                    window.re_energy_costs[re_enegry_key],
                    0.02
                );


                // 残計算計算
                this.result.year_kwh += tmp_kwh;
                og_year_price += tmp_og_price;
            }

            if(this.year.pay === 'bank'){
                ce_year_price -= 660;
            }
    
            if(ce_year_price){
                this.result.ce_year_price = ce_year_price.toLocaleString();
            }
            if(og_year_price){
                this.result.og_year_price = og_year_price.toLocaleString();
            }
            
            if(ce_year_price > og_year_price){
                const diff_price = (ce_year_price - og_year_price);
                this.result.diff_price = diff_price.toLocaleString();
                this.result.diff_price_text = 'お安く';
            } else {
                const diff_price = (og_year_price - ce_year_price);
                this.result.diff_price = diff_price.toLocaleString();
                this.result.diff_price_text = 'お高く';
            }
            
            const date = new Date();
            this.result.title = '年間試算結果';
            this.result.calc_title = '[電気料金単価による比較]';

            // scroll
            this.$smoothScroll({
                scrollTo: document.querySelector('#calc-end'),
                duration: 1000,
                offset: -50,
            });
        }
    }
});

/**
 * 料金から使用量の算出
 * 1kwh 〜 1000kwh
 * 
 * @param int price : 料金
 * @param string plan : 契約電力タイプ
 * @param object fuel_cost : 燃料調整単価割合
 * @param object re_energy : 再生可能エネルギー割合
 * 
 * @return int 使用量
 */
function _getKwhByPrice(price,base_cost,plus_cost,fuel_cost,re_energy_cost) {

    let next = 0;
    let kwh = 0;
    
    for($i=1;$i<1001;$i++){
        next = _sigleMonthCalcByKwh(base_cost,plus_cost,$i,fuel_cost,re_energy_cost);
        if(price < next){
            kwh = $i-1;
            break;
        }
        if($i === 1000){ kwh = $i; }
    }
    return kwh === 0 ? 1 : kwh;
}

/**
 * get re_energy_cost key
 * 
 * @param string month
 * @return 0 or 1
 */
function _getReEnergyKey(month) {
    if(month === '1月' || month === '2月' || month === '3月' || month === '4月'){
        return 0;
    }
    return 1;
}

/**
 * ひと月ごとのトータルを算出
 * 
 * @param base_cost int : 基本料金
 * @param plus_cost object : 会社別の割合
 * @param object calc : 計算の配列
 * @param int year_kwh : 年間使用料
 * @param object kwh_percents : 年間使用料の月割合
 * @param int kwh : 使用量
 * @param object fuel_costs : 燃料調整単価割合の配列
 * @param object re_energys : 再生可能エネルギー割合の配列
 * @param float discount : 割引を設定
 */
function _yearCalcByKwh(base_cost,plus_cost,year_kwh,kwh_percents,kwh,fuel_costs,re_energy_costs,discount) {
    let result = 0;
    let tmp_total = 0;

    Object.keys(kwh_percents).forEach(function(key){
        // 月別：使用量
        let tmp_kwh = Math.round(year_kwh * kwh_percents[key]);
        // 月別：燃料割合
        let tmp_fuel_cost = fuel_costs[key];
        // 月別：再生エネルギー割合
        let tmp_re_energy_key = _getReEnergyKey(key);
        let tmp_re_energy = re_energy_costs[tmp_re_energy_key];

        // ひと月の料金算出
        tmp_total = _sigleMonthCalcByKwh(base_cost, plus_cost, tmp_kwh, tmp_fuel_cost, tmp_re_energy,discount);

        result += tmp_total;
    });
    
    return result;
}


/**
 * 使用量からの料金算出
 * 
 * @param int base_cost : 会社別 × 電流タイプ別の基本料金
 * @param object plus_cost : 会社別の使用量毎の掛け率
 * @param int kwh : 使用量
 * @param float fuel_cost : 燃料調整単価割合
 * @param float re_energy : 再生可能エネルギー割合
 * @param float discount : 再生可能エネルギー割合
 */
function _sigleMonthCalcByKwh(base_cost,plus_cost,kwh,fuel_cost,re_energy,discount) {

    let result = 0;

    // 基本料金
    result = base_cost;
    // 計算料金
    result += _calcByKwh(plus_cost, kwh);
    
    // 割引
    if(discount) {
        result = result - Math.ceil(result * discount);
    }

    // 燃料調整費
    result += fuel_cost * kwh;
    // 再生可能エネルギー
    result += Math.floor(re_energy * kwh);

    return Math.floor(result);
}


/**
 * 純粋使用量の算出
 * 
 * @param object costs : 使用量毎の掛け率 / CE と OGで率が違う
 * @param int kwh : 使用量
 */
function _calcByKwh(costs, kwh) {
    let result = 0;
    let tmp_kwh = kwh;
    const s1 = 120;
    const s2 = 180;

    // 0〜120kwh
    if(tmp_kwh <= s1) {
        result = tmp_kwh * costs['120'];
        return result;
    } else {
        result = s1 * costs['120'];
        tmp_kwh -= s1;
    }

    // 121〜300kwh
    if(tmp_kwh <= s2) {
        result += tmp_kwh * costs['300'];
        return result;
    } else {
        result += s2 * costs['300'];
        tmp_kwh -= s2;
    }

    // 301kwh〜
    result += tmp_kwh * costs['301'];
    return result;
}